import React from 'react';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { FilterButtons } from 'apps/sigma2-ui/src/filters-v2/components/FilterButtons';
import cn from 'classnames';
import { FilterBoxError } from 'apps/sigma2-ui/src/filters-v2/components/FilterBoxError';
import { TranslatedContent } from 'libs/end-to-end/src/translation-content';

export interface FilterMenuSinglePanelBottomWithContentProps {
  /**
   * The error message to display or null if no error
   */
  errorTranslatedContent: TranslatedContent | null;

  /**
   * Callback when the cancel button is clicked
   */
  onCancel: () => void;

  /**
   * Callback when the apply button is clicked
   */
  onApply: () => void;

  /**
   * Whether or not the apply button is disabled
   */
  applyDisabled: boolean;
}

export type FilterMenuSinglePanelBottomProps =
  | 'none'
  | FilterMenuSinglePanelBottomWithContentProps;

export interface FilterMenuSinglePanelProps {
  /**
   * The filter name translated content
   */
  filterNameTranslatedContent?: TranslatedContent;

  /**
   * The content of the filter portion of the menu
   */
  filterContent: React.ReactNode;

  bottomProps: FilterMenuSinglePanelBottomProps;
}

export const FilterMenuSinglePanel = ({
  filterNameTranslatedContent,
  filterContent,
  bottomProps,
}: FilterMenuSinglePanelProps) => {
  return (
    <Spacing
      direction={'vertical'}
      size={'none'}
      className={'w-[290px] h-[360px] bg-white rounded-lg shadow-4px'}
    >
      {filterNameTranslatedContent && (
        <div className={'text-center border-b-[1px] border-gray-200 px-3 py-2'}>
          <S2Typography
            as={'span'}
            translatedContent={filterNameTranslatedContent}
            variant={'headline-7-alt'}
            textColorVariant={'gray-900'}
          />
        </div>
      )}

      <div className={cn('flex-1 p-3 relative')}>
        <div className={'absolute left-0 top-0 w-full h-full overflow-hidden'}>
          <div className={'h-full overflow-y-auto relative p-3 pb-0'}>
            {filterContent}
          </div>
        </div>
      </div>

      {bottomProps !== 'none' && (
        <Spacing direction={'vertical'} size={''} className={'p-3'}>
          {bottomProps.errorTranslatedContent && (
            <FilterBoxError
              errorTranslatedContent={bottomProps.errorTranslatedContent}
            />
          )}
          <FilterButtons
            onCancel={bottomProps.onCancel}
            onApply={bottomProps.onApply}
            appliedCount={0}
            applyDisabled={bottomProps.applyDisabled}
          />
        </Spacing>
      )}
    </Spacing>
  );
};
